import { navigate as nav } from 'gatsby';
const navigate = (path) => {
  nav(path);
};
export default navigate;
